import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useStatsStore } from "../../store/stats.store";

export const useOverallStats = () => {
  const setOverallData = useStatsStore((state) => state.setOverallData);

  return useMutation(PartnerApi.overallStats, {
    onSuccess: (data) => {
      setOverallData(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useCompanyOverallStats = () => {
  const setOverallData = useStatsStore((state) => state.setOverallData);

  return useMutation(PartnerApi.overallCompanyStats, {
    onSuccess: (data) => {
      setOverallData(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
